import { useRouter } from "next/router"
import { z } from "zod"

const querySchema = z.object({
  editing: z
    .custom<`${string}___${number}`>((value) => {
      if (typeof value !== "string") return false
      if (!value.includes("__")) return false
      const [resourceName, id] = value.split("__")
      return resourceName && id
    })
    .optional(),
})

export const useEditingId = (resourceName: string) => {
  const router = useRouter()
  const query = querySchema.parse(router.query)
  const stringId = query.editing?.split("__")[1]
  const resourceNameFromQuery = query.editing?.split("__")[0]
  const editingId = resourceNameFromQuery === resourceName && stringId ? parseInt(stringId) : null

  const setEditingId = (
    payload: (currentId: typeof editingId) => typeof editingId | typeof editingId
  ) => {
    const id = typeof payload === "function" ? payload(editingId) : payload

    const query = {
      ...router.query,
    }

    delete query.editing

    if (typeof id === "number") {
      query[`editing`] = `${resourceName}__${id}`
    }

    router.push(
      {
        pathname: router.pathname,
        query,
      },
      undefined,
      { shallow: true }
    )
  }

  return {
    editingId,
    setEditingId,
  }
}
